import { call, takeLatest } from 'redux-saga/effects';
import { WorkedHoursReportActions } from '../constants';
import { WorkedHoursReportApi } from 'src/services/end-points';
import { GetWorkedHoursReportsAction, GetWorkedHoursReportsCsvAction } from '../actions/workedHoursReport-actions';
import { resolveApiCall, ResolverApiFailure, handleError } from '../../services/api-handlers/api-resolver';
import { exportToCsv } from '../../services/exports/csv';
import { groupWorkedHoursReportToCsv } from '../../helpers/workedHoursReport/groupCsv';
import { toast } from 'react-toastify';

function* handleFetchWorkedHoursReports(action: GetWorkedHoursReportsAction): any {
    const { comparison, period, hours, dateFrom, dateTo, serviceTypeProvider } = action.payload;

    yield resolveApiCall(
        action,
        () => WorkedHoursReportApi.getWorkedHoursReports({ comparison, period, hours, dateFrom, dateTo, serviceTypeProvider }),
        undefined,
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data?.detail ?? result.error.message ?? 'Unknown error');
            }
            handleError(result);
        },
    );
}

function* handleFetchWorkedHoursReportsCsv(action: GetWorkedHoursReportsCsvAction): any {
    const { comparison, period, hours, dateFrom, dateTo, serviceTypeProvider } = action.payload;

    yield resolveApiCall(
        action,
        () => WorkedHoursReportApi.getWorkedHoursReports({ comparison, period, hours, dateFrom, dateTo, serviceTypeProvider }),
        function* (data) {
            const rows = groupWorkedHoursReportToCsv(data.payload?.data ?? []);
            exportToCsv('invoiced-hours-report.csv', rows);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data?.detail ?? result.error.message ?? 'Unknown error');
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS, handleFetchWorkedHoursReports);
    yield takeLatest(WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS_CSV, handleFetchWorkedHoursReportsCsv);
}
